import { render, staticRenderFns } from "./InterfaceSTP.vue?vue&type=template&id=736fd342&scoped=true&"
import script from "./InterfaceSTP.vue?vue&type=script&lang=ts&"
export * from "./InterfaceSTP.vue?vue&type=script&lang=ts&"
import style0 from "./InterfaceSTP.vue?vue&type=style&index=0&id=736fd342&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736fd342",
  null
  
)

export default component.exports